import React from 'react';
import { PageHeader, CTASmall } from '../components/PageBits';
import { BRAND } from '../mock/data';
import { Users, Award, Palette, Megaphone } from 'lucide-react';

const focusAreas = [
  { icon: Users, title: 'Volunteer Mobilization', desc: 'Bringing young people together for service-based initiatives.' },
  { icon: Award, title: 'Leadership Development', desc: 'Helping youth learn responsibility through real community work.' },
  { icon: Palette, title: 'Cultural Participation', desc: 'Encouraging young members to preserve and celebrate shared heritage.' },
  { icon: Megaphone, title: 'Event Support', desc: 'Leading coordination, logistics, communication, and ground-level action.' },
];

const Reyocc = () => (
  <>
    <PageHeader kicker="REYOCC — Youth Wing" title="Young energy for charity," accent="culture, and community leadership." intro="REYOCC is the youth wing of REFOCC, created to channel the energy, creativity, and commitment of young people into meaningful social action. It gives students and young professionals a platform to serve, organize, learn, and lead." />
    <section className="py-8"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"><img src={`${BRAND}/reyocc.jpg`} alt="REYOCC" className="w-full rounded-[2rem] aspect-[16/7] object-cover"/></div></section>

    {/* Role of REYOCC */}
    <section className="py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-refocc-dark mb-5">Role of REYOCC</h2>
            <p className="text-refocc-dark/70 leading-relaxed">REYOCC supports REFOCC programmes through volunteering, event coordination, cultural activities, outreach drives, and youth-led initiatives. It builds confidence among young members while preparing them to become responsible community leaders.</p>
            <div className="mt-6"><CTASmall label="Join REYOCC" /></div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[{n:'700+',l:'Active youth volunteers'},{n:'25+',l:'Workshops a year'},{n:'12',l:'REYOCC chapters'},{n:'4',l:'Annual flagship events'}].map(x=>(
              <div key={x.l} className="bg-refocc-dark text-refocc-cream rounded-2xl p-6">
                <div className="font-serif text-3xl text-refocc-orange">{x.n}</div>
                <div className="text-xs mt-1 text-refocc-cream/70">{x.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* Focus Areas */}
    <section className="py-16 bg-refocc-cream">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-serif text-3xl md:text-4xl text-refocc-dark text-center mb-10">Focus Areas</h2>
        <div className="grid sm:grid-cols-2 gap-6">
          {focusAreas.map(x => (
            <div key={x.title} className="flex gap-5 bg-white rounded-2xl p-6 border border-refocc-dark/10">
              <div className="w-12 h-12 rounded-full bg-refocc-orange/15 text-refocc-orange flex items-center justify-center shrink-0"><x.icon size={20}/></div>
              <div>
                <div className="font-serif text-xl text-refocc-dark">{x.title}</div>
                <p className="text-sm text-refocc-dark/65 mt-2 leading-relaxed">{x.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Reyocc;
